type DocTitleProps = {
  title: string;
};

/**
 * Sets the browser tab title via React 19 document metadata (hoisted to
 * `<head>`). Prefer one per route — `PageTitle` already includes one.
 * The app root keeps a base `<title>Ready to Activate</title>` as fallback
 * when no route DocTitle is mounted. Blank `title` renders `"RTA"`.
 *
 * Children must be one string (template literal), not adjacent JSX text nodes.
 * @see https://react.dev/reference/react-dom/components/title
 */
const DocTitle = ({ title }: DocTitleProps) => {
  const trimmed = title.trim();
  return <title>{trimmed ? `${trimmed} | RTA` : "RTA"}</title>;
};

export default DocTitle;
